import React from 'react'
import Swal from 'sweetalert2'
import moment from 'moment'

import DateField from '@shared/form-fields/date'
import SelectField from '@shared/form-fields/select'
import Loader from '@shared/loader'
import findSelected from '@helpers/find-selected'
import { ValidatorForm } from 'react-form-validator-core'
import Modal from 'react-responsive-modal'

import Wizard from '@modules/form-wizard'
import islands from '@constants/islands'
import SERVICE_PROPS from '@helpers/extract-service-props'
import toastr from '@modules/toastr'
// import { BUSINESS_FIELDS } from '@modules/form-wizard/utils'
import AdminActions from './_admin-actions'

class BahamaHostCompanyRegistration extends React.Component {
  state = {
    profile: '',
    session_numb: '',
    session_date: '',
    venue: '',
    record: null,
    confirmModal: false,
    loading: false,
    confirmAcceptance: false,
    formData: null,
    metadata: null,
  }

  defaults = {
    client_submitted: true,
  }

  read_params = {
    // admin: true,
    label: ' ',
    default: 'Default',
    values: {
      'Default': {
        client_submitted: true,
      },
    },
  }

  async componentDidMount () {
    // try {
    //   const { data } = await $app.axios.get('/profiles/')
    //   this.setState({ profile: data })
    // } catch (error) {
    //   console.error(error)
    // }
    try {
      const { data } = await $app.axios.get(`/services/metadata?service[name]=bahama host company`)

      // console.log(data)

      const bahamahost_data = data.metadata?.find(
        m => m.desc == 'bahamahost companies corporate session desc'
      )

      this.setState({
        metadata: bahamahost_data?.data,
      })
    } catch (error) {
      console.error(error)
    }
  }

  resource = '/bahama_host_companies'
  form_key = 'bahama_host_company'

  pausable  = true // Resumable Form Application
  // postpaid = true
  // business_only = true

  
  skip_location = true
  custom_acceptance = false

  hide_columns = ['Name']
  columns = props => [
    {
      name: 'Company Name',
      selector: 'r.company_name',
      sortable: true,
      cell: r => (
        <span onClick={props.view(r)} data-action>
          {`${r.company_name || r.trading_name}`.capitalize()}
        </span>
      ),
    },

    {
      name: 'Program Type',
      selector: row => row.industry_type?.capitalize() || 'N/A',
      sortable: true,
      searchable: r => r.industry_type,
    },
    {
      name: 'Session Number',
      selector: row => row.session_numb || 'Not Set',
      sortable: true,
      searchable: r => r.session_numb,
    },
    {
      name: 'Session Date',
      selector: row => row.session_date,
      cell: r => (
        <span>{moment(r?.session_date).format('MMMM Do YYYY') || 'N/A'}</span>
      ),
      sortable: true,
      searchable: r => r.session_date,
    },
    // {
    //   name: 'Paid',
    //   selector: row => row.payment_status?.capitalize() || 'N/A',
    //   sortable: true,
    //   searchable: r => r.payment_status,
    // },
  ]

  fee = ({ industry_type, employees }) => {
    let total_cost = 0
    let cert_cost = 150
    if (industry_type == 'Water Sports Training') {
      cert_cost = 25
    } else if (industry_type == 'BahamaHost Recertification') {
      cert_cost = 75
    } else if (industry_type == 'Certificate Reprint') {
      cert_cost = 5
    } else if (industry_type == 'Corporate PSD') {
      cert_cost = 25
    } else if (industry_type == 'Customer Service Training') {
      cert_cost = 75
    }

    // If employees length is greater than 19 apply 20% discount
    if (employees.length > 19) {
      const discount = (100 - 20) / 100.00 // 20% discount
      total_cost = (cert_cost * employees.length) * discount
    } else {
      total_cost = cert_cost * employees.length
    }

    return total_cost
  }

  // free = true


  hide_buttons = {
    status: true,
    deny: true,
    email: $app.roles?.includes('senior_officer'),
  }

  // filter_records = r => $app.is_citizen
  //   || r.island_location === this.state.profile.island
  //   || this.state.profile.island === 'New Providence'

  // before_apply = () => {
  //   const { profile } = this.state;

  //   const employer = profile.addresses[1]?.business_name || null;

  //   if (!profile.education_level && !employer) {
  //     return "In order to apply for this form, both the Employment Details and Education Details sections in the Profile tab must be filled out.";
  //   }
  // };

  validate = ({ employees, agent_contact_list }) => {
    if (employees.length < 2) {
      return 'You must add at least 2 participants before submitting this application.'
    }

    if (agent_contact_list.some(ac => !ac.nib || ac.nib.length !== 8)) {
      return 'All agent contact NIB numbers must be 8 digits.'
    }

    if (employees.some(e => !e.nib || e.nib.length !== 8)) {
      return 'All employee NIB numbers must be 8 digits.'
    }
  }


  custom_actions = [
    {
      text: 'Enter Session Details',
      icon: 'clipboard-list',
      test: r => r.payment_status && $app.roles?.includes('officer'),
      fn: record => this.setState({ record }),
    },
    {
      text: 'Approve Application',
      icon: 'check-square',
      test: r => $app.roles?.includes('officer'),
      fn: async record => {
        const { isDismissed } = await Swal.fire({
          title:
            'Are you sure that you would like to approve this application?',
          text: 'By clicking "Confirm", you are acknowleding that you have reviewed this application and are satisfied with its contents. Would you like to approve?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Confirm',
        })
        
        if (isDismissed) return

        const { resource, form_key, props } = this
        const { history, location } = props
        const { axios } = $app

        try {
          await axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'approved',
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            view.application_decision = 'approved'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application status successfully set')
        } catch (error) {
          console.error(error)
          Swal.fire(
            'Oops...',
            'There has been an error with the status change of the application',
            'error'
          )
        }
      }
    },
    {
      text: 'Deny',
      icon: 'ban',
      test: r => $app.roles?.includes('officer'),
      fn: async record => {
        const { isDismissed } = await Swal.fire({
          icon: 'error',
          title: 'Confirm Denial',
          text: 'Are you sure you want to deny this application?',
          confirmButtonText: 'Deny',
          showCancelButton: true,
        })
        if (isDismissed) return

        const { resource, form_key, props } = this
        const { history, location } = props
        const { axios } = $app

        try {
          await axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'denied',
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            view.application_decision = 'denied'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application status successfully set')
        } catch (error) {
          console.error(error)
          Swal.fire(
            'Oops...',
            'There has been an error with the status change of the application',
            'error'
          )
        }
      }
    },
  ]

  requirePreviousSessionNumb = ['Water Sports Training', 'Tour Guide Training', 'Certificate Reprint', 'BahamaHost Recertification', 'Corporate PSD']

  fields = form => [
    {
      name: 'client_submitted',
      label: 'Submitted By Client',
      type: 'select:bool',
      view: true,
      save: true,
      hide: true,
    },
    {
      name: 'form_num',
      label: 'Application ID#',
      save: true,
      hide: true,
    },
    {
      name: 'session_numb',
      label: 'Session Number',
      hide: true,
      view: true,
    },
    {
      name: 'venue',
      hide: true,
      view: true,
    },
    {
      name: 'session_date',
      label: 'Start Date of Session',
      hide: true,
      view: true,
    },
    // ...BUSINESS_FIELDS(form),
    {
      heading: 'Company Details',
      view: false,
    },
    {
      name: 'company_name',
      label: 'Company Name',
    },
    {
      name: 'trading_name',
      label: 'Company Trading Name',
      required: false,
    },
    {
      name: 'company_email',
      label: 'Company Email',
      type: 'email',
    },
    {
      name: 'company_address',
      label: 'Company Address',
    },
    {
      name: 'phone_number',
      label: 'Company Phone #',
      type: 'phone',
    },

    "::Session Details",
    // {
    //   name: 'other_reason',
    //   label: 'Other',
    //   hide: form.reason != 'Other' && form.reason !== form.other_reason,
    //   view: false,
    // },
    {
      name: 'time_of_session',
      label: 'Time of Session',
      options: ['Morning', 'Evening'],
      // options: ['Morning', 'Afternoon', 'Evening'],
    },
    {
      name: 'industry_type',
      label: 'Program Type',
      options: [
        // {label: "Public Service Driver Training ($150)", value: 'Public Service Driver Training'},
        // {label: "Corporate Public Service Driver ($25)", value: 'Corporate PSD'},
        // {label: "Tour Guide Training ($150)", value: 'Tour Guide Training'},
        // {label: `Water Sports Training ($25)`, value: 'Water Sports Training'},
        {label: "General ($150)", value: 'BahamaHost General'},
        // {label: "BahamaHost Recertification ($75)", value: 'BahamaHost Recertification'},
        {label: "Customer Service Training ($75)", value: 'Customer Service Training'},
        // {label: "Certificate Reprint ($5)", value: 'Certificate Reprint'},
        // 'Customer Service Training',
        // { name: 'BahamaHost General', value: 'BahamaHost General'},
        // 'Specialized Training',
      ],
    },
    // {
    //   name: 'in_business',
    //   type: 'select:bool',
    //   label: 'Are you currently in the Water Sports business?',
    //   hide: form.industry_type != 'Water Sports Training',
    //   required: false,
    //   hint: `${!form.in_business ? 'If not in the <b>Water Sports business</b> the certificate <b>fee</b> is <b>$25</b>' : ''}`,
    // },
    // {
    //   name: 'cert_type',
    //   label: 'Type of Certificate (Reprint)',
    //   hide: form.industry_type != 'Certificate Reprint',
    //   options: [
    //     'Public Service Driver Training',
    //     'Tour Guide Training',
    //     'Water Sports Training',
    //     'BahamaHost General',
    //     'BahamaHost Recertification',
    //     'Certificate Reprint',
    //     // 'BahamaHost Seminar', 
    //   ],
    // },
    {
      name: 'previous_session_numb',
      label: 'Previous Session Number',
      type: 'integer',
      hide: !this.requirePreviousSessionNumb.includes(form.industry_type),
      // view: true,
      onBlur: async v => {
        if (v) {
          // regex to match the session number format
          // This regex strictly enforces:
          // - Strings consist only of digits
          // - They start at 040 or higher
          // - Strings like 000 will not pass
          const regex = /^(0[4-9]\d|[1-9]\d{2,})$/
          const found = v.match(regex);

          if (!found) {
            await Swal.fire({
              title: 'Error',
              html: `
                * The session number is invalid. </br></br>  <b>See format examples, "040", "129"</b>.
              `,
              icon: 'error'
            }
            )
            return { previous_session_numb: '' }
          }

          return { previous_session_numb: v }
        }
      }
    },
    {
      name: 'island_location',
      options: islands,
    },
    {
      name: 'island_sub_location',
      label: '',
      hide: !['Andros', 'Eleuthera'].includes(form.island_location),
      options: [
        'North',
        'Central',
        'South',
      ],
    },

    '::Agent Contact Section',
    {
      name: 'agent_contact_list',
      label: 'Agent Contact Details',
      required: true,
      rowLabel: 'Contact',
      fields: [
        {
          name: 'first_name',
          required: true,
        },
        {
          name: 'middle_name',
          required: false,
        },
        {
          name: 'last_name',
          required: true,
        },
        {
          name: 'gender',
          options: ['male', 'female'],
          required: true,
        },
        {
          name: 'nib',
          label: 'NIB #',
          type: 'integer',
          required: true,
          onBlur: async (value, x, htmlElem) => {
            if (value && value.length !== 8) {
              toastr.error('NIB number must be 8 digits.')

              const divElement = htmlElem.currentTarget
              const splitBy = divElement.getAttribute('name')?.split('::')
              const index = splitBy[1]
              const agentContactList = form.agent_contact_list
              agentContactList[index].nib = agentContactList[index].nib.slice(0, 8)

              return { agent_contact_list: agentContactList }
            }
          }
        },
        {
          name: 'position',
          required: false,
        },
        {
          name: 'email',
          type: 'email',
          required: false,
        },
        // {
        //   name: 'identification_upload',
        //   label: 'Government Issued Photo ID',
        //   type: 'file:all',
        //   required: false,
        // },
      ],
    },

    '::Employee Section',
    {
      name: 'employees',
      label: 'Employee Details',
      required: true,
      rowLabel: 'Participant',
      fields: [
        {
          name: 'first_name',
          required: true,
        },
        {
          name: 'middle_name',
          required: false,
        },
        {
          name: 'last_name',
          required: true,
        },
        {
          name: 'gender',
          options: ['male', 'female'],
          required: true,
        },
        {
          name: 'nib',
          label: 'NIB #',
          type: 'integer',
          required: true,
          onBlur: async (value, x, htmlElem) => {
            if (value && value.length !== 8) {
              toastr.error('NIB number must be 8 digits.')

              const divElement = htmlElem.currentTarget
              const splitBy = divElement.getAttribute('name')?.split('::')
              const index = splitBy[1]
              const employeeList = form.employees
              employeeList[index].nib = employeeList[index].nib.slice(0, 8)

              return { employees: employeeList }
            }
          }
        },
        {
          name: 'position',
          required: false,
        },
        {
          name: 'email',
          type: 'email',
          required: false,
        },
        {
          name: 'previous_session_numb',
          label: 'Previous Session Number',
          type: 'integer',
          hide: !this.requirePreviousSessionNumb.includes(form.industry_type),
          required: false,
          onBlur: async (v, s, htmlElem) => {
            if (v) {
              // console.log(v, 's\n', s, 'index \n', htmlElem, 'a \n', htmlElem.currentTarget)
              // Grab the index of the div element from the name attribute
              const divElement = htmlElem.currentTarget
              const splitBy = divElement.getAttribute('name')?.split('::')
              const index = splitBy[1]
              const employeesList = form.employees

              // regex to match the session number format
              // This regex strictly enforces:
              // - Strings consist only of digits
              // - They start at 040 or higher
              // - Strings like 000 will not pass
              const regex = /^(0[4-9]\d|[1-9]\d{2,})$/
              const found = v.match(regex);
    
              if (!found) {
                await Swal.fire({
                  title: 'Error',
                  html: `
                    * The session number is invalid. </br></br>  <b>See format examples, "040", "129"</b>.
                  `,
                  icon: 'error'
                }
                )

                employeesList[index].previous_session_numb = ''

                return { employees: employeesList }
              }
    
              employeesList[index].previous_session_numb = v
              return { employees: employeesList }
            }
          }
        }
        // {
        //   name: 'identification_upload',
        //   label: 'Government Issued Photo ID',
        //   type: 'file:all',
        //   required: false,
        // },
      ],
    },
    // {
    //   name: 'photo_upload',
    //   key: 'image.1',
    //   label: 'Government Issued ID',
    //   type: 'file:image',
    //   // key: f => f.image,
    // },
    // {
    //   name: 'exempt_payment',
    //   label:
    //     'By clicking here, you are certifying that this application is exempt from payment.',
    //   type: 'checkbox',
    //   required: false,
    //   hide: true,
    //   save: true,
    // },
    // {
    //   name: 'non_refundable',
    //   type: 'checkbox',
    //   view: false,
    //   required: true,
    //   label: `
    //     Registration fee is nonrefundable and remains
    //     valid for a period of six (6) months).type
    //   `,
    // }
    // {
    //   name: 'exempt_reason',
    //   label: 'What is your reason for payment exemption?',
    //   type: 'textarea',
    // },
  ]


  closeModal = () => this.setState({ record: null })

  on = {
    select: v => this.setState({ session_numb: v.length && v[0].value }),
    input: name => ev =>
      this.setState({ [name]: ev.target.value.replace(/[^0-9a-z ]/gi, '') }),

    date: val => this.setState({ session_date: val }),

    submitSessionDetails: async () => {
      this.setState({ loading: true })

      const { state, props, resource, form_key } = this
      const { history, location } = props
      const { record, session_numb, venue, session_date } = state
      const { axios } = $app
      // console.log(state);

      try {
        await axios.put(resource + '/update_session_details', {
          [form_key]: {
            form_num: record.form_num,
            session_numb,
            venue,
            session_date,
          },
        })

        if (location.state?.view) {
          const view = { ...location.state.view }
          view.application_decision = 'approved'
          view.fields[2].value = session_numb
          // view.fields[5].value = venue
          view.fields[3].value = moment(session_date).format('MMMM Do YYYY')

          history.replace(location.pathname, { ...location.state, view })
        }

        toastr.success(
          'Success',
          'Session Number, Session Date and Venue successfully set'
        )
      } catch (error) {
        console.error(error)
        toastr.error(
          'Error',
          'Unable to set Session Number, Session Date and Venue'
        )
        return
      }

      // try {
      //   await axios.post('/emails', {
      //     email: record.user.email,
      //     subject:
      //       'MyGateway Portal Update - BahamaHost Certified Service Professionals',
      //     message: `
      //       Dear ${record.user.first_name.capitalize()},
      //       <br/>
      //       Congratulations! Your BahamaHost application has been approved and we are so excited to have you join us.
      //       Your details are as follows:
      //       <br/>
      //       <ul>
      //       <li>Session Number: <strong>${session_numb}</strong></li>
      //       <li>Session Date: <strong>${moment(session_date).format(
      //         'Do MMMM, YYYY'
      //       )}</strong></li>
      //       <li>Venue: <strong>${record?.venue}</strong></li>
      //       </ul>
      //       <br/><br />
      //       Your assigned trainer will be in contact with you shortly to provide the login details and instructions.
      //       <br/>

      //       If you need assistance, please contact us at: Telephone: (242) 302-2000 extensions 2760 and 2470, Email: info.bahamahost@bahamas.com
      //       <br/>
      //       Thank you for using the MyGateway Portal.
      //     `,
      //   })

      //   toastr.success('Success', 'Confirmation email successfully sent')
      // } catch (err) {
      //   console.error(err)
      //   toastr.error('Error', 'Unable to send email')
      // }

      this.setState({ loading: false, record: null })
    },
  }

  venue_options = [
    { label: 'Virtual', value: 'virtual' },
    { label: 'In-person', value: 'in-person' },
  ]

  render = () => {
    const { state, on, closeModal } = this
    const metadata = this.state.metadata

    const sessions = metadata?.filter(d => d.active)
      .map(d => ({ value: d?.session_numb, label: d?.session_numb }))

    return (
      <React.Fragment>
        <Loader loading={this.state.loading} />
        <Wizard {...SERVICE_PROPS(this)} />
        <Modal
          open={state.record}
          style={{ width: 480 }}
          onClose={closeModal}
          center
        >
          <div className='modal-header'>
            <h5 className='modal-title'>Set Details</h5>
          </div>
          <ValidatorForm onSubmit={on.submitSessionDetails}>
            <div className='modal-body'>
              <p>Only enter session details if you want all employees listed in the application form to have their session numbers and dates set to a single value</p>
              <div className='form-group form-show-validation'>
                <label htmlFor='session_numb'>
                  Session Number
                  <span className='required-label'>*</span>
                </label>
                <SelectField
                  onChange={on.select}
                  name='session_numb'
                  options={sessions || []}
                  values={findSelected(sessions, state.session_numb)}
                  value={state.session_numb}
                  validators={['required']}
                  errorMessages={['Session Number must be selected']}
                  className='form-control w-100'
                />
              </div>
              <div className='form-group form-show-validation'>
                <label htmlFor='venue'>
                  Venue
                  <span className='required-label'>*</span>
                </label>
                {/* <InputField
                  name='venue'
                  value={state.venue}
                  onChange={on.input('venue')}
                  className='form-control'
                  validators={['required']}
                  errorMessages={['Required']}
                  disabled
                  required
                /> */}
                <SelectField
                  name='venue'
                  value={state.venue}
                  options={this.venue_options}
                  onChange={ev => this.setState({ venue: ev?.[0]?.value })}
                  className='form-control'
                  validators={['required']}
                  errorMessages={['Required']}
                  required
                />
              </div>
              <div className='form-group form-show-validation'>
                <label htmlFor='session_date'>
                  Start Date of Session
                  <span className='required-label'>*</span>
                </label>
                <DateField
                  type='date'
                  className='form-control'
                  name={'end_date'}
                  onChange={on.date}
                  selected={state.session_date}
                  value={state.session_date}
                  validators={['required']}
                  errorMessages={['Required']}
                  dateFormat='do MMMM, yyyy'
                  showYearDropdown
                />
              </div>
            </div>
            <div className='modal-footer'>
              <button
                className='btn btn-round mr-2'
                aria-label='Close'
                onClick={closeModal}
              >
                Cancel
              </button>
              <input
                className='btn custom-btn btn-round'
                type='submit'
                value='Submit'
              />
            </div>
          </ValidatorForm>
        </Modal>
      </React.Fragment>
    )
  }
}

export default AdminActions(BahamaHostCompanyRegistration)
